export const employeeImportHeaders = [
  "First Name",
  "Last Name",
  "Gender",
  "Employee ID",
  "Email",
  "Phone number",
  "Title",
  "Office Location",
  "Full Net Salary",
  "Savings",
  "Account holder name",
  "Bank Name",
  "Bank Code",
  "Account number",
  "IBAN(optional)",
  "NIN",
  "BVN",
];

export const isString = new RegExp(/^[a-zA-Z\s]*$/g);
export const isNumber = new RegExp(/((\d+)((\.\d{1,2})?))$/g);
export const isEmail = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i);

// Normalize gender values to M or F
export const normalizeGender = (gender) => {
  if (!gender) return gender;
  const normalized = gender.trim().toLowerCase();
  if (normalized === "male" || normalized === "m") {
    return "M";
  } else if (normalized === "female" || normalized === "f") {
    return "F";
  }
  return gender.trim();
};
